const limitOptions = [10, 20, 50, 100];
export default limitOptions;
